module.exports = __webpack_public_path__ + "static/media/shell-box-image.2bfc8303.png";